import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';

declare global {
  interface Window {
    $crisp: unknown[];
    CRISP_WEBSITE_ID: string;
  }
}

export function CrispWidget() {
  const { user } = useAuth();

  // Inicializar Crisp uma vez
  useEffect(() => {
    if (!import.meta.env.VITE_CRISP_WEBSITE_ID) return;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = import.meta.env.VITE_CRISP_WEBSITE_ID;

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      delete (window as Window & { $crisp?: unknown[] }).$crisp;
    };
  }, []);

  // Identificar o usuário quando logado
  useEffect(() => {
    if (!user || !window.$crisp) return;

    const crisp = window.$crisp as unknown[][];
    crisp.push(['set', 'user:email', [user.email]]);
    crisp.push([
      'set',
      'user:nickname',
      [user.first_name || user.username || user.email],
    ]);
    crisp.push([
      'set',
      'session:data',
      [[
        ['escola', user.profile?.school_name ?? ''],
        ['role', user.profile?.role ?? ''],
        ['plano', 'trial'],
      ]],
    ]);
  }, [user]);

  return null;
}
